// Librerie Esterne
import React from "react";  
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; 

interface Props {
    name: string;
    subTitle: string;
    imageUrl: string;
    link: string;
    description: string;
}

const LocationItem: React.FC<Props> = ({ name, subTitle, imageUrl, link, description }) => {

    const { t } = useTranslation();

    return (
        <article className="location-item row align-items-center">
                <div className="col-12 col-lg-6 col-xl-7 mb-4 mb-lg-0">
                    <img src={imageUrl} alt={name} className="img-fluid"  />
                </div>
                <div className="col-12 col-lg-6 col-xl-5">
                    <h3>{name}</h3>
                    <p className="mb-3 mb-lg-4">{subTitle}</p>
                    <p className="mb-4 mb-xl-5" dangerouslySetInnerHTML={{ __html: description as string }} />
                    <Link className="btn btn-primary" to={link}>
                        <span>{t('homePage.locationsSection.btnText')}</span>
                    </Link>
                </div>
        </article>
    );
};

export default LocationItem;